let previousTimeStamp;
let animating = false;
const stepFunctions = {};

function step(timestamp) {
  if (previousTimeStamp !== undefined) {
    const dt = timestamp - previousTimeStamp;
    const fns = Object.values(stepFunctions);
    for (const fn of fns) fn(dt);
  }

  previousTimeStamp = timestamp;
  if (animating) window.requestAnimationFrame(step);
}

export function startAnimation() {
  animating = true;
  window.requestAnimationFrame(step);
}

export function stopAnimation() {
  animating = false;
}

export function addStepFunction(id, fn) {
  stepFunctions[id] = fn;
}

export function removeStepFunction(id) {
  delete stepFunctions[id];
}
